import {css} from "styled-components";

export const TransactionTransferStyled = css`
  .add-transfer-from-button {
    display: flex;
    align-items: center;
    max-width: 100%;
    color: #237804;
    border-color: #389e0d;

    &:hover, &:focus {
      color: #389e0d;
      border-color: #52c41a;
    }

    .anticon:last-child {
      position: relative;
      flex: 1;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .anticon:first-child {
      position: relative;
      top: 1px;
      font-size: 16px;
    }
  }

  .transfer-from-modal {
    .ant-modal-body {
      height: 60vh;
      overflow-y: auto;
    }
  }

  .transfer-from-timeline {
    .ant-timeline-item-head, .ant-timeline-item-tail {
      top: 20px;
    }

    .ant-timeline-item-head {
      font-size: 16px;
    }

    .ant-timeline-item-tail {
      height: calc(100% + 5px)
    }

    .ant-timeline-item-content {
      top: 0;
    }

    .transfer-from-timeline-icon {
      color: black;
    }
  }



`;
